<template>
  <section class="pb-0 pb-lg-5 pt-0 pt-lg-3">
    <div class="d-block d-md-flex align-items-center pt-0 pt-md-0">
      <div class="px-3 pb-4 mb-2 d-block d-md-none">
        <div class="d-flex rl">
          <div class="block-h full-h"></div>
          <div class="ps-4">
            <div class="f-xmlg bld l-op">Wildflower Community</div>
            <div class="f-nm l-op">Saratoga Springs, UT 84045</div>
          </div>
        </div>
      </div>

      <div id="map" class="full fade-in-item right"></div>
      <div
        class="full d-flex align-items-center fade-in-item left justify-content-center justify-content-xl-start ps-0"
      >
        <div
          class="text-left px-3 px-md-5 py-3 py-md-5 py-md-0"
          style="max-width: 800px"
        >
          <div class="d-none d-md-flex rl">
            <div class="block-h full-h"></div>
            <div class="ps-4">
              <div class="f-xmlg bld l-op">Wildflower Community</div>
              <div class="f-nm l-op">Saratoga Springs, UT 84045</div>
            </div>
          </div>
          <div class="f-lg mt-1 mt-md-4 l-op lh-lg">
            Situated on the edge of the foothills along the northwest boundary
            of Saratoga Springs, Wildflower plays host to some of Utah’s most
            stunning mountain and valley views. And being at the edge of it all,
            you are a short drive away from gazing at the stars in the desert,
            or enjoying everything the city has to offer.
          </div>
          <a
            href="https://www.liveatwildflower.com/"
            target="_blank"
            class="btn mt-4 btn-light lbld shadow-sm"
          >
            Learn more
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="18px"
              class="ms-3"
              viewBox="0 -960 960 960"
              width="18px"
              fill="#000"
            >
              <path
                d="m600-200-57-56 184-184H80v-80h647L544-704l56-56 280 280-280 280Z"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  mounted() {
    ((g) => {
      var h,
        a,
        k,
        p = "The Google Maps JavaScript API",
        c = "google",
        l = "importLibrary",
        q = "__ib__",
        m = document,
        b = window;
      b = b[c] || (b[c] = {});
      var d = b.maps || (b.maps = {}),
        r = new Set(),
        e = new URLSearchParams(),
        u = () =>
          h ||
          (h = new Promise(async (f, n) => {
            await (a = m.createElement("script"));
            e.set("libraries", [...r] + "");
            for (k in g)
              e.set(
                k.replace(/[A-Z]/g, (t) => "_" + t[0].toLowerCase()),
                g[k]
              );
            e.set("callback", c + ".maps." + q);
            a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
            d[q] = f;
            a.onerror = () => (h = n(Error(p + " could not load.")));
            a.nonce = (m.querySelector("script[nonce]") || {}).nonce || "";
            m.head.append(a);
          }));
      d[l]
        ? console.warn(p + " only loads once. Ignoring:", g)
        : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)));
    })({
      key: "AIzaSyDu-qDG7lMGvDP9WrL2w3DmD9-Xf2CDihQ",
      v: "weekly",
      // Use the 'v' parameter to indicate the version to use (weekly, beta, alpha, etc.).
      // Add other bootstrap parameters as needed, using camel case.
    });

    let map;
    let styles = [
      { featureType: "all", stylers: [{ saturation: -100 }, { gamma: 0.0 }] },
    ];

    async function initMap() {
      const { Map } = await google.maps.importLibrary("maps");
      const { AdvancedMarkerElement } = await google.maps.importLibrary(
        "marker"
      );
      const position = { lat: 40.402186730525244, lng: -111.94036219106492 };

      map = new Map(document.getElementById("map"), {
        center: position,
        styles: styles,
        zoom: 15,
      });

      var marker = new google.maps.Marker({
        position: position,
        map: map,
      });
    }

    initMap();
  },
};
</script>

<style>
#map {
  height: 450px; /* The height is 400 pixels */
  width: 100%;
}
</style>
